<template>
  <div class="findpage">
    <div class="sou">
      <div class="ser">搜索结果共{{ totalcount }}条</div>
      <ul>
        <li v-for="(item, index) in list" :key="index" @click="toview(item.id)">
          <p>{{ item.title }}</p>
          <p v-html="item.content" ref="dom">
            三行情诗 ｜ 恒生电子2015年报如是说三行情诗 ｜
            恒生电子2015年报如是说…
          </p>
          <p>{{ item.timeline }}</p>
        </li>
      </ul>
      <div class="page">
        <div class="prev" @click="prev">上一页</div>
        <div class="lint">
          <span>{{ list == "" ? 0 : page }}</span>
          <span>/</span>
          <span>{{ pages }}</span>
        </div>
        <div class="next" @click="next">下一页</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      search: "",
      page: 1,
      limit: 4,
      list: [],
      totalcount: 0,
      pages: 0,
    };
  },
  //数据请求
  methods: {
    getData() {
      if (!this.search) return;
      let data = {
        keyword: this.search,
        pageSize: this.limit,
        pageNo: this.page,
      };
      this.$fetch({
        url: "index.php/search/topsearch",
        type: "post",
        data: this.$qs.stringify(data),
      }).then((res) => {
        if (res.code == 0) {
          // console.log(res);
          this.list = res.data.list;
          this.totalcount = res.data.totalcount;
          this.pages = res.data.pages;
          this.$nextTick(() => {
            this.getxt();
          });
        }
      });
    },
    //下一页
    next() {
      if (this.page >= this.pages) return;
      this.page++;
      this.getData();
      window.scrollTo(0, 0);
    },
    //上一页
    prev() {
      if (this.page <= 1) return;
      this.page--;
      this.getData();
      window.scrollTo(0, 0);
    },
    //跳转详情
    toview(id) {
      // console.log(id);
      this.$router.push({ path: "/newsview", query: { id: id } });
    },
    //字符超出隐藏
    getxt() {
      var str = this.$refs.dom;
      for (var i = 0; i < str.length; i++) {
        str[i].innerText = str[i].innerText.slice(0, 50) + "...";
      }
    },
  },
  mounted() {
    this.search = this.$route.query.search;
    this.getData();
  },
  watch: {
    $route(val) {
      this.search = val.query.search;
      this.getData();
    },
  },
};
</script>

<style scoped>
.sou .ser {
  font-size: 24px;
  font-weight: 400;
  color: #999999;
  line-height: 33px;
  margin: 36px 0 36px 30px;
}
.sou ul {
  min-height: 60vh;
}
.sou ul li {
  margin: 40px 30px 0;
  border-bottom: 2px dotted #e6e6e6;
  box-sizing: border-box;
}
.sou ul li p:nth-child(1) {
  font-size: 36px;
  color: #333333;
  line-height: 50px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.sou ul li p:nth-child(2) {
  font-size: 28px;
  font-weight: 400;
  color: #666666;
  line-height: 40px;
  margin: 15px 0 30px 0;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.sou ul li p:nth-child(3) {
  font-size: 24px;
  font-weight: 400;
  color: #999999;
  line-height: 33px;
  padding-bottom: 30px;
}
.page {
  width: 100%;
  height: 104px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 55px 0 80px 0;
}
.page .next,
.page .prev {
  width: 168px;
  height: 72px;
  background: #ffffff;
  border: 1px solid #dddddd;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  font-weight: 400;
  color: #000000;
}
.page .lint span {
  font-size: 36px;
  font-weight: 400;
}
.page .lint span:nth-child(1) {
  color: #396aff;
}
</style>